import { render } from "./ScenicSpotDetails.vue?vue&type=template&id=3205d7d8&scoped=true"
import script from "./ScenicSpotDetails.vue?vue&type=script&lang=js"
export * from "./ScenicSpotDetails.vue?vue&type=script&lang=js"

import "./ScenicSpotDetails.vue?vue&type=style&index=0&id=3205d7d8&lang=scss&scoped=true"

import exportComponent from "E:\\xlckj\\大屏\\monitor\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3205d7d8"]])

export default __exports__